import slug from 'constants/slug'
import createBreadcrumb from 'shared/breadcrumb/hoc'
//import Icon from 'themes/icon'

export default createBreadcrumb({
  create: {
    id: 'create',
    href: slug.qa.create,
    name: 'Create'
  },
  edit: {
    id: 'edit',
    href: slug.qa.edit,
    name: 'Edit'
  },
  list: {
    id: 'base',
    href: slug.qa.list,
    name: 'Q&A'
  }
})



// WEBPACK FOOTER //
// ./src/containers/qa/breadcrumb.js